// QUITAR BARRA AL FINAL DE URL
export default {
  authentication: "https://um02idrw57.execute-api.us-east-2.amazonaws.com/prod",
  masterdata: "https://0v1znma3tb.execute-api.us-east-2.amazonaws.com/prod",
  foundation: "https://zpsdeu5pd4.execute-api.us-east-2.amazonaws.com/prod",
  enableFakeData: false
};
